import {
	SET_CALL_RECEPTION_STATUS,
	OPEN_CALL_CONTROL_WIDGET,
	CLOSE_CALL_CONTROL_WIDGET,
	SET_POSSIBLE_CUSTOMERS,
	SET_LAST_SSE_MESSAGE,
	ADD_CREATED_APPEAL,
	SET_AUTHORIZATION_SUCCESS,
	ADD_NEW_INTERACTION,
	CLEAR_CALL_TEMP_STATE,
	CLOSE_INTERACTION,
	CLEAR_SESSION,
	SET_TIMER,
	SET_OPERATOR_ACTIONS,
	SET_CALL_STATION,
	OPEN_USER_POPUP,
	OUT_OF_SERVICE,
	CLEAR_ERROR_MSG,
	SET_OUT_PHONE_ERROR_MSG,
	SET_IN_PHONE_ERROR_MSG,
	UPDATE_CREATED_APPEAL_NAME,
	SET_RINGING_SSE_MESSAGE,
} from 'constants/actions';
import {
	UNKNOWN_ERROR_MSG, LOST_CONNECTION_MSG, SERVER_ERROR_MSG,
	LOST_CONNECTION_TOTALY_MSG, SERVER_NOT_RESPONSE_MSG,
} from 'constants/errors';
import URLS from 'config/urls';
import { SseEvents } from 'constants/index';
import { openUserPopup } from './ui';
import { sessionStorageService } from 'services/settingsService';

import * as api from 'api';

export function updateCreatedAppealName(appeal) {
	return (dispatch) => {
		dispatch({
			type: UPDATE_CREATED_APPEAL_NAME,
			payload: { appeal },
		});
	};
}

export function transferCall(params) {
	return (dispatch) => {
		return dispatch(api.sn.dialog.call.initiate(params.data)).unwrap()
			.then((response) => {
				if (errorCodesHandler(response.errorCode, dispatch)) {
					return null;
				}
			})
			.catch(console.error);
	};
}

export function getCallStation() {
	return (dispatch) => {
		dispatch({
			type: SET_CALL_STATION,
			payload: 'finesse',
		});
	};
}

export function getOperatorStatus(userLogin) {
	return (dispatch) => {
		dispatch(api.mw.admin.state.stateList.initiate({ userLogin })).unwrap()
			.then((response) => {
				dispatch({
					type: SET_OPERATOR_ACTIONS,
					payload: response.result,
				});
			});
	};
}

export function setCallReceptionStatus(stateCode, userLogin) {
	return (dispatch) => {
		if (stateCode && userLogin) {
			dispatch(api.mw.admin.state.stateSet.initiate({
				userLogin,
				stateCode,
			}));
		}

		if (stateCode && stateCode !== 'returntowork') {
			sessionStorageService.remove(SSE_SESSION_STORAGE_KEY);
		}

		dispatch({
			type: SET_CALL_RECEPTION_STATUS,
			payload: { callReceptionStatus: stateCode },
		});
	};
}

export function setTimer(timer) {
	return {
		type: SET_TIMER,
		payload: timer,
	};
}

const getPossibleCustomers = phone => (dispatch) => {
	const params = {
		data: {
			phone,
			limit: 50,
		},
		jsonType: true,
	};

	return dispatch(api.mw.callHistory.callHistorySearch.initiate({
		phone,
		limit: 50,
	}))
		.unwrap()
		.then((response) => {
			if (response.success && Array.isArray(response.result)) {
				dispatch(setPossibleCustomers(response.result));
			} else {
				throw new Error('Possible customers request error');
			}
		})
		.catch((error) => {
			console.error(error);
			dispatch(setPossibleCustomers([]));
		});
};

export const setAuthorizationSuccess = (phoneNumber, userLogin) => (dispatch) => {
	sessionStorageService.set(SSE_SESSION_STORAGE_KEY, {
		phoneNumber,
		userLogin,
		savedAt: Date.now(),
	});

	dispatch({
		type: SET_AUTHORIZATION_SUCCESS,
		payload: { phoneNumber },
	});
};

export const resumeSseSession = (currentUserLogin) => (dispatch) => {
	const session = sessionStorageService.get(SSE_SESSION_STORAGE_KEY);

	if (!session) {
		return Promise.resolve(false);
	}

	if (currentUserLogin && session.userLogin && currentUserLogin !== session.userLogin) {
		sessionStorageService.remove(SSE_SESSION_STORAGE_KEY);
		return Promise.resolve(false);
	}

	return dispatch(api.sn.server.alive.initiate())
		.unwrap()
		.then((response) => {
			if (errorCodesHandler(response.errorCode, dispatch)) {
				return false;
			}

			if (response?.result?.status === 'Unauthorized') {
				sessionStorageService.remove(SSE_SESSION_STORAGE_KEY);
				dispatch({ type: CLEAR_SESSION });
				dispatch(openUserPopup());
				return false;
			}

			dispatch(setAuthorizationSuccess(session.phoneNumber || '', currentUserLogin || session.userLogin));

			if (currentUserLogin) {
				dispatch(getOperatorStatus(currentUserLogin));
			}

			dispatch(subscribeToCalls());
			return true;
		})
		.catch(() => false);
};

export const clearCallState = () => ({
	type: CLEAR_CALL_TEMP_STATE,
});

export const clearSession = () => ({
	type: CLEAR_SESSION,
});

let eventSource;
let reconnectTimer = null;
let reconnectAttempts = 0;
let beforeUnloadBound = false;
let lastConnectAt = null;
let lastMessageAt = null;
let healthTimer = null;

const SSE_RECONNECT_BASE_MS = 1000;
const SSE_RECONNECT_MAX_MS = 30000;
const SSE_STALL_MS = 90000;
const SSE_SESSION_STORAGE_KEY = 'sseSession';

const CALL_CONTEXT_FINAL_EVENTS = [
	SseEvents.NOT_READY,
	SseEvents.READY,
	SseEvents.LOGOUT,
	SseEvents.RESERVED,
	SseEvents.WORK,
	SseEvents.WORK_READY,
];

const isCallContextFinalEvent = event => CALL_CONTEXT_FINAL_EVENTS.includes(event);

const logSse = (message, meta) => {
	if (meta) {
		console.log(`[SSE] ${message}`, meta);
	} else {
		console.log(`[SSE] ${message}`);
	}
};

const sendSseClientLog = (event, meta = {}) => {

	const payload = JSON.stringify({
		event,
		...meta,
		timestamp: Date.now(),
	});

	try {
		if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
			if (typeof Blob !== 'undefined') {
				const blob = new Blob([payload], { type: 'application/json' });
				navigator.sendBeacon(URLS.core.sse_client_log.url, blob);
				return;
			}
			navigator.sendBeacon(URLS.core.sse_client_log.url, payload);
			return;
		}
	} catch (e) {
		// noop
	}

	if (typeof fetch !== 'function') {
		return;
	}

	fetch(URLS.core.sse_client_log.url, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: payload,
		keepalive: true,
	}).catch(() => {});
};

export const closeCallEventStream = () => () => {
	if (eventSource) {
		logSse('close stream (manual)');
		sendSseClientLog('close', { reason: 'manual' });
		eventSource.close();
		eventSource = null;
	}
	if (reconnectTimer) {
		clearTimeout(reconnectTimer);
		reconnectTimer = null;
	}
	if (healthTimer) {
		clearInterval(healthTimer);
		healthTimer = null;
	}
};

const getEventSourceStateMessage = (readyState) => {
	switch (readyState) {
	case 0:
		return 'CONNECTING';
	case 1:
		return 'OPEN';
	case 2:
		return 'CLOSED';

	default:
		return null;
	}
};

export const subscribeToCalls = () => (dispatch, getState = () => ({})) => {
	if (reconnectTimer) {
		clearTimeout(reconnectTimer);
		reconnectTimer = null;
	}
	eventSource && dispatch(closeCallEventStream());
	dispatch({ type: CLEAR_ERROR_MSG });

	logSse('connect start', { url: URLS.core.sse_stream.url });
	sendSseClientLog('connect_start', { url: URLS.core.sse_stream.url });

	if (!beforeUnloadBound && typeof window !== 'undefined') {
		window.addEventListener('beforeunload', () => {
			if (eventSource) {
				logSse('close stream (beforeunload)');
				sendSseClientLog('close', { reason: 'beforeunload' });
				eventSource.close();
			}
		});
		beforeUnloadBound = true;
	}

	eventSource = new EventSource(URLS.core.sse_stream.url);

	eventSource.addEventListener('open', (event) => {
		reconnectAttempts = 0;
		lastConnectAt = Date.now();
		lastMessageAt = lastConnectAt;
		const state = getEventSourceStateMessage(event.currentTarget.readyState);
		logSse('connected', { state });
		sendSseClientLog('open', { state });
	});

	let lastSseEvent = null;

	eventSource.addEventListener('message', (message) => {
		const sseMessage = JSON.parse(message.data);
		const callStateBeforeMessage = getState()?.call || {};
		const activeDialogId = callStateBeforeMessage.ringingMessage?.uniqueId || callStateBeforeMessage.callId;
		lastMessageAt = Date.now();

		if (lastSseEvent === sseMessage.event && sseMessage.event !== SseEvents.ALIVE) {
			return;
		}

		lastSseEvent = sseMessage.event;

		dispatch(setLastSseMessage({
			...sseMessage,
			timestamp: Date.now(),
		}));

		if (isCallContextFinalEvent(sseMessage.event)) {
			dispatch(closeInteraction(activeDialogId));
			dispatch(clearCallState());
			return;
		}

		switch (sseMessage.event) {
		case SseEvents.RINGING: {
			dispatch(setRingingSseMessage(sseMessage));
			dispatch(getPossibleCustomers(sseMessage.phone));
			dispatch(openCallControlWidget());
			break;
		}

		case SseEvents.HANGUP: {
			// Transfer/consult може завершити окремий Dialog, поки оператор
			// лишається у TALKING з основним дзвінком. Чекаємо user_state.*.
			break;
		}

		case SseEvents.DISCONNECTION: {
			dispatch(closeCallEventStream());
			dispatch(clearSession());
			dispatch(openUserPopup());
			break;
		}

		case SseEvents.ALIVE: {
			dispatch(api.sn.server.alive.initiate())
				.unwrap()
				.then((response) => {
					if (errorCodesHandler(response.errorCode, dispatch)) {
						return null;
					}

					dispatch({ type: CLEAR_ERROR_MSG });

					switch (response.result.status) {
					case 'Unauthorized':
						closeCallEventStream();
						dispatch({ type: CLEAR_SESSION });
						dispatch({ type: OPEN_USER_POPUP });
						break;
					case 'OUT_OF_SERVICE':
						dispatch({ type: OUT_OF_SERVICE });

						dispatch({
							type: SET_IN_PHONE_ERROR_MSG,
							payload: LOST_CONNECTION_MSG,
						});

						break;
					}
				})
				.catch((error) => {
					console.error('error', error);
				});

			break;
		}

		default:
			break;
		}
	});

	eventSource.addEventListener('error', (e) => {
		const state = getEventSourceStateMessage(e.currentTarget.readyState);

		const meta = {
			state,
			reconnectAttempts,
			sinceMs: lastConnectAt ? Date.now() - lastConnectAt : null,
			lastMessageMs: lastMessageAt ? Date.now() - lastMessageAt : null,
		};

		logSse('error', meta);
		sendSseClientLog('error', meta);
		if (e.currentTarget.readyState === EventSource.CLOSED) {
			reconnectAttempts += 1;

			const delay = Math.min(
				SSE_RECONNECT_MAX_MS,
				SSE_RECONNECT_BASE_MS * (2 ** (reconnectAttempts - 1)),
			);

			logSse('reconnect scheduled', { attempt: reconnectAttempts, delayMs: delay });
			sendSseClientLog('reconnect_scheduled', { attempt: reconnectAttempts, delayMs: delay });
			reconnectTimer = setTimeout(() => {
				reconnectTimer = null;
				dispatch(subscribeToCalls());
			}, delay);
		}
	});

	if (healthTimer) {
		clearInterval(healthTimer);
	}
	healthTimer = setInterval(() => {
		if (!eventSource || !lastMessageAt) {
			return;
		}

		if (eventSource.readyState !== EventSource.OPEN) {
			return;
		}

		const gap = Date.now() - lastMessageAt;

		if (gap > SSE_STALL_MS) {
			logSse('stall detected', { gapMs: gap });
			sendSseClientLog('stall', { gapMs: gap });
			eventSource.close();
			eventSource = null;
			reconnectAttempts += 1;

			const delay = Math.min(
				SSE_RECONNECT_MAX_MS,
				SSE_RECONNECT_BASE_MS * (2 ** (reconnectAttempts - 1)),
			);

			logSse('reconnect scheduled (stall)', { attempt: reconnectAttempts, delayMs: delay });
			sendSseClientLog('reconnect_scheduled', { attempt: reconnectAttempts, delayMs: delay, reason: 'stall' });
			reconnectTimer = setTimeout(() => {
				reconnectTimer = null;
				dispatch(subscribeToCalls());
			}, delay);
		}
	}, 15000);
};

export const setLastSseMessage = message => ({
	type: SET_LAST_SSE_MESSAGE,
	payload: { message },
});

export const setRingingSseMessage = message => ({
	type: SET_RINGING_SSE_MESSAGE,
	payload: { message },
});

export const setPossibleCustomers = customers => ({
	type: SET_POSSIBLE_CUSTOMERS,
	payload: { customers },
});

export const openCallControlWidget = () => ({
	type: OPEN_CALL_CONTROL_WIDGET,
});

export const closeCallControlWidget = () => ({
	type: CLOSE_CALL_CONTROL_WIDGET,
});

export const addCreatedAppeal = appeal => ({
	type: ADD_CREATED_APPEAL,
	payload: { appeal },
});

export function addNewInteraction(payload) {
	return (dispatch) => {
		dispatch({
			type: ADD_NEW_INTERACTION,
			payload,
		});
	};
}

export const removeInteraction = () => ({
	type: CLOSE_INTERACTION,
});

export const closeInteraction = uniqueId => (dispatch, getState) => {
	const interactionId = getState().call.callInteractionId;

	dispatch(removeInteraction(uniqueId));

	if (!interactionId) {
		return;
	}

	return dispatch(api.mw.interaction.interactionClose.initiate({ interactionId }))
		.unwrap()
		.then()
		.catch(console.error);
};

function errorCodesHandler(error, dispatch) {
	function serverErorr() {
		dispatch({ type: OUT_OF_SERVICE });

		dispatch({
			type: SET_IN_PHONE_ERROR_MSG,
			payload: SERVER_ERROR_MSG,
		});
	}

	function closeConnectionAndOpenLogin() {
		closeCallEventStream();
		dispatch({ type: CLEAR_SESSION });
		dispatch({ type: OPEN_USER_POPUP });
	}

	function serverNotResponse() {
		dispatch({ type: OUT_OF_SERVICE });

		dispatch({
			type: SET_IN_PHONE_ERROR_MSG,
			payload: SERVER_NOT_RESPONSE_MSG,
		});
	}

	const errorMap = {
		unknown_error: () => {
			closeConnectionAndOpenLogin();

			dispatch({
				type: SET_OUT_PHONE_ERROR_MSG,
				payload: UNKNOWN_ERROR_MSG,
			});
		},
		no_login_id: () => {
			dispatch({ type: OUT_OF_SERVICE });

			dispatch({
				type: SET_IN_PHONE_ERROR_MSG,
				payload: UNKNOWN_ERROR_MSG,
			});
		},
		finesse_offline: () => {
			if (eventSource) {
				dispatch({ type: OUT_OF_SERVICE });

				dispatch({
					type: SET_IN_PHONE_ERROR_MSG,
					payload: LOST_CONNECTION_MSG,
				});
			} else {
				dispatch({ type: CLEAR_SESSION });
				dispatch({ type: OPEN_USER_POPUP });
			}
		},
		finesse_alive_unknown_status: () => {
			closeConnectionAndOpenLogin();

			dispatch({
				type: SET_OUT_PHONE_ERROR_MSG,
				payload: LOST_CONNECTION_TOTALY_MSG,
			});
		},
		asterisk_connection_error: serverNotResponse,
		asterisk_sendAction_error: serverNotResponse,
		finesse_invalid_request: serverErorr,
		finesse_failed: serverErorr,
		finesse_uknown_error: serverErorr,
		invalid_request: serverErorr,
	};

	if (errorMap[error]) {
		errorMap[error]();
		return true;
	}
}

export const __testables = {
	getEventSourceStateMessage,
	errorCodesHandler,
	sendSseClientLog,
	isCallContextFinalEvent,
};
